import { IIconProps } from "../types"

export default function IconUL6(props: IIconProps) {
  const width = props.size || props.width || (105 / 5) * 3
  const height = props.size || props.height || (100 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 105 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.7458 1.03187C59.4781 0.272113 48.7716 0.182142 40.5042 1.20182C32.2469 2.21149 26.4287 4.33081 22.49 6.44014C18.5513 8.55946 16.4819 10.6788 14.0727 14.9074C11.6635 19.1361 8.90435 25.484 6.51512 31.792C4.11589 38.09 2.07654 44.348 1.12685 51.6756C0.167153 58.9933 0.297112 67.3706 1.07686 73.9285C1.86661 80.4864 3.32614 85.2249 5.46546 89.0337C7.60477 92.8424 10.4339 95.7115 13.3029 97.361C16.182 99.0105 19.0811 99.4403 23.1798 99.0604C27.2685 98.6806 32.5468 97.491 37.1053 96.4813C41.6539 95.4616 45.4826 94.6119 48.6916 94.232C51.9006 93.8521 54.5097 93.9421 57.0289 94.4019C59.5581 94.8718 62.0073 95.7115 64.6465 96.6412C67.2856 97.5809 70.1147 98.5906 72.6339 98.8405C75.1631 99.1004 77.3824 98.5906 80.4414 97.191C83.5004 95.8015 87.3992 93.5122 90.3882 90.7231C93.3673 87.934 95.4366 84.6351 97.306 81.2462C99.1854 77.8572 100.865 74.3884 101.975 71.0094C103.084 67.6205 103.624 64.3216 103.774 61.4925C103.934 58.6534 103.704 56.2842 103.354 53.785C103.014 51.2858 102.554 48.6666 99.9852 41.3489C97.426 34.0313 92.7575 22.0151 89.3486 15.1174C85.9496 8.21957 83.8103 6.44014 80.8213 4.84065C77.8422 3.23116 74.0135 1.79163 66.7458 1.03187Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
